import React, { useContext, useState } from "react";
import { CustomTextField } from "./../../../../Assets/Elements";
import toast from "react-hot-toast";
import { AuthContext } from "../../../../Context/AuthContextProvider";
import PropTypes from "prop-types";

function TicketReply({ ticket }) {
  TicketReply.propTypes = {
    ticket: PropTypes.any.isRequired,
  };
  const { loginUser, replyTicket } = useContext(AuthContext);
  const [showReplyForm, setShowReplyForm] = useState(true);
  const [ownerComments, setOwnerComments] = useState("");
  const [isReplying, setIsReplying] = useState(false);

  const handleReplyForm = () => {
    setShowReplyForm(!showReplyForm);
  };

  const handleClear = () => {
    setOwnerComments("");
    setShowReplyForm(true);
  };

  const handleReply = async () => {
    if (!ownerComments.trim()) {
      toast.error("Please enter comments");
      return;
    }
    setIsReplying(true);

    const replyData = {
      replyBy: {
        userId: loginUser._id,
        userName: loginUser.username,
      },
      replyComments: ownerComments.trim(),
    };

    try {
      await replyTicket(ticket._id, replyData);
      setOwnerComments("");
      setIsReplying(false);
    } catch (error) {
      toast.error(`Failed to reply ticket, error : ${error}`);
      setIsReplying(false);
    }
  };

  return (
    <div className="mb-[18px]">
      {showReplyForm ? (
        <span
          className={`py-[8px] px-[12px] rounded-[8px] bg-[#b99653] hover:bg-[#93693b]  `}
        >
          <button
            className="text-[white]"
            onClick={() => {
              // setSelectedAdmin(loginAdmin);
              handleReplyForm(true);
            }}
          >
            Reply
          </button>
        </span>
      ) : (
        <div>
          <CustomTextField
            label="Add Reply..."
            value={ownerComments}
            onChange={(e) => setOwnerComments(e.target.value)}
            width="100%"
            isRequired={false}
            rows={4} // Optional: Adds a textarea-like appearance
            multiline // Enables multiline input
          />
          <div className="flex gap-[12px] mt-[16px]">
            <span
              className={`py-[8px] px-[12px] rounded-[8px] bg-[#b99653] hover:bg-[#93693b]" `}
            >
              <button
                className="text-[white]"
                onClick={() => {
                  // setSelectedAdmin(loginAdmin);
                  handleClear(true);
                }}
              >
                Cancel
              </button>
            </span>
            <span
              className={` py-[8px] px-[12px] rounded-[8px]  bg-[#93693b] hover:bg-[#b99653]`}
            >
              <button
                className="text-[white]"
                onClick={() => {
                  // setSelectedAdmin(loginAdmin);
                  handleReply(true);
                }}
              >
                {isReplying ? "Replying..." : "Reply"}
              </button>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default TicketReply;
